import RecordBase from './Base';
import { useTranslation } from 'react-i18next';

export default class EpayTransactionRecord extends RecordBase {
  static defaultAttributes = {
    type: '',
    mode: '',
    username: '',
    max_timeout: '',
    terminal_id: '',
    tx_id: '',
    tx_ref: '',
    local_datetime: '',
    chars_per_line: '',
    ean: '',
    amount: '',
    currency: '',
    language: '',
    valid_to: '',
    server_datetime: '',
    receipt_quantity_lines: '',
    receipt_body_lines: '',
    result: '',
    result_text: '',
    serial: '',
    pin: '',
    pin_id: '',
    product: '',
    product_id: '',
    epay_user: '',
    epay_user_id: '',
    status: '',
    limit: '',
    created_at: '',
    updated_at: '',
  };

  static _attributeNames = null;

  static get attributeNames() {
    const { t } = useTranslation();
    const trAttr = (attr) => t(`epayTransactions.attributes.${attr}`);
    if (!this._attributeNames) {
      this._attributeNames = {
        type: trAttr('type'),
        mode: trAttr('mode'),
        username: trAttr('username'),
        max_timeout: trAttr('max_timeout'),
        terminal_id: trAttr('terminal_id'),
        tx_id: trAttr('tx_id'),
        tx_ref: trAttr('tx_ref'),
        local_datetime: trAttr('local_datetime'),
        chars_per_line: trAttr('chars_per_line'),
        ean: trAttr('ean'),
        amount: trAttr('amount'),
        currency: trAttr('currency'),
        language: trAttr('language'),
        valid_to: trAttr('valid_to'),
        server_datetime: trAttr('server_datetime'),
        receipt_quantity_lines: trAttr('receipt_quantity_lines'),
        receipt_body_lines: trAttr('receipt_body_lines'),
        result: trAttr('result'),
        result_text: trAttr('result_text'),
        serial: trAttr('serial'),
        pin: trAttr('pin'),
        pin_id: trAttr('pin_id'),
        product: trAttr('product'),
        product_id: trAttr('product_id'),
        epay_user: trAttr('epay_user'),
        epay_user_id: trAttr('epay_user_id'),
        status: trAttr('status'),
        limit: trAttr('limit'),
        created_at: trAttr('created_at'),
        updated_at: trAttr('updated_at'),
      };
    }
    return this._attributeNames;
  }
}
